module.exports = __webpack_public_path__ + "components/weather-icon/static/daylightsnow-4b79c7faabc1040f43a2fe27f0f42b1f.webp";